var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.is_loaded)?_c('app-spinner'):[_c('app-cells',[_c('app-date-picker',{staticClass:"datepicker--220",attrs:{"clearable":false,"placeholder":"Specify a date"},on:{"input":_vm.onDateChange},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('app-schedule',{attrs:{"schedule":_vm.schedule}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }